import pluralize from '../procedures/pluralize.js';

// Mirrors services.ocr.max_pages in apigateway-ms; the gateway and ocr-ms enforce it as well.
export const OCR_PAGE_LIMIT = 25;

export const OCR_PAGE_LIMIT_EXCEEDED = 'OCR_PAGE_LIMIT_EXCEEDED';
export const OCR_ATTEMPT_LIMIT_REACHED = 'OCR_ATTEMPT_LIMIT_REACHED';

export const exceedsOcrPageLimit = (pages, limit = OCR_PAGE_LIMIT) => Number(pages) > limit;

export const ocrPageLimitMessage = (pages, limit = OCR_PAGE_LIMIT) =>
  `Nie można zeskanować pliku: ma ${ pages } ${ pluralize(Number(pages), 'stronę', 'strony', 'stron') }, a limit to ${ limit }. Podziel go na mniejsze pliki.`;

export const ocrAttemptLimitMessage = () =>
  'Nie można ponowić skanowania, bo poprzednie próby się nie powiodły. Uzupełnij dane z pliku ręcznie.';

export const OCR_START_FAILED_MESSAGE = 'Nie udało się uruchomić skanowania. Odśwież stronę i spróbuj ponownie.';

export const isOcrRetryBlocked = file => file?.ocr?.can_retry === false;

export const ocrErrorMessage = error => {
  const body = error?.response?.data?.error;

  switch (body?.code) {
    case OCR_PAGE_LIMIT_EXCEEDED:
      return ocrPageLimitMessage(body.pages, body.limit);
    case OCR_ATTEMPT_LIMIT_REACHED:
      return ocrAttemptLimitMessage();
    default:
      return null;
  }
};
